import { render, staticRenderFns } from "./MedicineInfo.vue?vue&type=template&id=46793072&scoped=true"
import script from "./MedicineInfo.vue?vue&type=script&lang=js"
export * from "./MedicineInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46793072",
  null
  
)

export default component.exports